export default function formatPhone({ phone }) {
	if (!phone) return ""
	if(phone.includes("-"))
	{
		return phone;
	}
	const areaCode = phone.substring(0, 3)
	const prefix = phone.substring(3, 6)
	const lineNumber = phone.substring(6)

	return `(${areaCode}) ${prefix}-${lineNumber}`
}
